import React, { useState } from 'react';
import { Layers, Table2, Coins } from 'lucide-react';
import VersionSetupModal from './BudgetSetup/VersionSetupModal';
import GLLinesSetupModal from './BudgetSetup/GLLinesSetupModal';
import CurrencySetupModal from './BudgetSetup/CurrencySetupModal';
import { ListSection, ListRow, PrimaryButton } from '../components/RowList';

const BudgetSetup = () => {
  // State to handle which setup modal is currently open
  const [activeModal, setActiveModal] = useState(null); // 'versions' | 'gl-lines' | null

  return (
    // SCROLL WRAPPER APPLIED HERE
    <div className="h-full overflow-y-auto font-sans bg-slate-100 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-6 py-10">

        <div className="mb-10">
          <h1 className="m-0 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">Budget Setup</h1>
          <p className="mt-2 text-base text-slate-500 dark:text-slate-400">
            Configure budget versions and establish General Ledger line rules for planning.
          </p>
        </div>

        {/* SECTION 1: Budget Versions */}
        <ListSection title="Version Management">
          <ListRow
            icon={Layers}
            title="Budget Versions"
            description="Create, update, deactivate, or delete planning versions. Versions can only be deleted if no dependent ledger data exists."
            actions={<PrimaryButton onClick={() => setActiveModal('versions')}>Open</PrimaryButton>}
          />
        </ListSection>

        {/* SECTION 2: GL Budget Setup */}
        <ListSection title="Ledger Configuration">
          <ListRow
            icon={Table2}
            title="GL Budget Lines"
            description="Define which combinations of GL Accounts, Cost Centres, and Sites are active. Toggle bottom-up (P×Q) calculations."
            actions={<PrimaryButton onClick={() => setActiveModal('gl-lines')}>Open</PrimaryButton>}
          />
        </ListSection>

        {/* SECTION 3: Currencies */}
        <ListSection title="Currency Configuration">
          <ListRow
            icon={Coins}
            title="Currencies & Conversion Rates"
            description="Set your base currency and maintain the conversion rate of every other currency against it."
            actions={<PrimaryButton onClick={() => setActiveModal('currencies')}>Open</PrimaryButton>}
          />
        </ListSection>

      </div>

      {/* Modals / Drawers */}
      {activeModal === 'versions' && (
        <VersionSetupModal onClose={() => setActiveModal(null)} />
      )}
      
      {activeModal === 'gl-lines' && (
        <GLLinesSetupModal onClose={() => setActiveModal(null)} />
      )}

      {activeModal === 'currencies' && (
        <CurrencySetupModal onClose={() => setActiveModal(null)} />
      )}
    </div>
  );
};

export default BudgetSetup;

// ---------------------------------------------------------------------------
// Modals
// ---------------------------------------------------------------------------
// VersionSetupModal and GLLinesSetupModal are each imported from their own
// files under ./BudgetSetup/.